import { Button, Card, DatePicker, Form, Input, Spin } from 'antd';
import React from "react";
import moment from "moment";

class Create extends React.Component {
  constructor() {
    super();
    this.state = {
      showManpower: '',
    }
  }

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }


  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();
    const backToModule = this.props.location.search.split("=")[1];

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
        // if (backToModule==='jobCard'){
        //   const urlBackToJobCard=`/job-card/report/${match.params.id}`;
        //   this.props.onSubmit(values, match.params.id, urlBackToJobCard);
        // } else {
        //   this.props.onSubmit(values, match.params.id);
        // }
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  searchManpower = (id, searchString) => {
    this.setState({ showManpower: id });
    this.props.searchManpower(searchString)
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { showManpower } = this.state;
    const { data, loading, filters, title, resource, form, searchManpower, manpower } = this.props;
    const statusUpdateLength = (data && data.statusUpdate && data.statusUpdate.length) || 0;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={<div>Job Card Number - {data && data.jobCardNo}</div>}>
          {
            <Form onSubmit={this.handleSubmit} layout="vertical">

              <div key={statusUpdateLength} style={style}>
                <div>
                  <Form.Item key={`${statusUpdateLength}5`} label={'Date'}>
                    {getFieldDecorator(`statusUpdate[${statusUpdateLength}]['date']`, {
                      rules: [{ required: true, message: `Date is required!` }],
                      initialValue: undefined,
                    })(<DatePicker />)
                    }
                  </Form.Item>
                  <Form.Item key={`${statusUpdateLength}0`} label={'Reason for Change in Date of Complettion'}>
                    {getFieldDecorator(`statusUpdate[${statusUpdateLength}]['reasonForChangeInDate']`, {
                      rules: [{ required: true, message: `Reason for Change In Date is required!` }],
                      initialValue: '',
                    })(<Input placeholder={'Enter Reason for Change in Date'} />)
                    }
                  </Form.Item>
                  <Form.Item key={`${statusUpdateLength}1`} label={'New Completion Date'}>
                    {getFieldDecorator(`statusUpdate[${statusUpdateLength}]['newCompletionDate']`, {
                      rules: [{ required: true, message: `New Completion Date is required!` }],
                      initialValue: undefined,
                    })(<DatePicker />)
                    }
                  </Form.Item>
                </div>
              </div>
              {statusUpdateLength > 0 ? <div className='gx-mb-2 gx-mt-3'>Previous Updates</div> : ''}
              {
                data.statusUpdate && data.statusUpdate.sort(function (a, b) {
                  return new Date(b.date) - new Date(a.date);
                }).map((item, index) => {
                  return <div key={index} style={style}>
                    <div>
                      <Form.Item key={`${index}5`} label={'Date'}>
                        {getFieldDecorator(`statusUpdate[${index}]['date']`, {
                          rules: [{ required: false, message: `Date is required!` }],
                          initialValue: item && item.date && moment(item.date),
                        })(<DatePicker disabled />)
                        }
                      </Form.Item>
                      <Form.Item key={`${index}0`} label={'Reason for Change in Date of Complettion'}>
                        {getFieldDecorator(`statusUpdate[${index}]['reasonForChangeInDate']`, {
                          rules: [{ required: false, message: `Reason for Change In Date is required!` }],
                          initialValue: item && item.reasonForChangeInDate,
                        })(<Input disabled />)
                        }
                      </Form.Item>
                      <Form.Item key={`${index}1`} label={'New Completion Date'}>
                        {getFieldDecorator(`statusUpdate[${index}]['newCompletionDate']`, {
                          rules: [{ required: false, message: `New Completion Date is required!` }],
                          initialValue: item && item.newCompletionDate && moment(item.newCompletionDate)
                        })(<DatePicker disabled />)
                        }
                      </Form.Item>
                    </div>
                  </div>
                })
              }
              <Form.Item>
                <Button type="primary" className="gx-mb-0 gx-mt-4" htmlType="submit" loading={loading}>
                  {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                </Button>
              </Form.Item>
            </Form>
          }
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
